import { FunctionFieldProps, FunctionField, useRefresh, useResourceContext } from 'react-admin';
import { makeStyles } from '@mui/styles';
import { Button } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

import { useRequest } from '@hooks';
import { doctypeHttp } from '@network';
import { Doctype } from '@types';

export const DoctypePosition = (props: Partial<FunctionFieldProps>) => {
  return (
    <FunctionField
      {...props}
      sortable={false}
      render={(record: any) => (
        <PositionWidget doctype={record} />
      )}
    />
  );
};

const PositionWidget = ({ doctype }: {doctype: Doctype}) => {
  const cls = useStyles();
  const refresh = useRefresh();
  const resource = useResourceContext();

  const { loading: loadingUp, submit: submitUp } = useRequest(async () => {
    await doctypeHttp.move(doctype.id, 'up', resource);
    refresh();
  });

  const { loading: loadingDown, submit: submitDown } = useRequest(async () => {
    await doctypeHttp.move(doctype.id, 'down', resource);
    refresh();
  });

  return (
    <div onClick={e => e.stopPropagation()} className={cls.box}>
      <Button
        loading={loadingUp}
        onClick={submitUp}
        icon={<ArrowUpOutlined />}
        type="ghost"
        className={cls.btn}
      ></Button>

      <Button
        loading={loadingDown}
        onClick={submitDown}
        icon={<ArrowDownOutlined />}
        type="ghost"
        className={cls.btn}
      ></Button>
    </div>
  );
};

const useStyles = makeStyles({
  box: {},
  btn: {
    marginBottom: 15,
  },
});
